import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/project/Hero/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/Visibility/visibility.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/lib/utils/useMergeRefs.ts");
